// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-container {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
}

.form-steps {
  width: 100%;
}

.form-group {
  align-items: flex-start;
  display: flex;
  flex: 1 1;
  flex-direction: column;
  justify-content: flex-start;
  min-width: 0;
  padding: 40px 0 0 70px;
  position: relative;
}

.step {
  border-right: 1px solid rgba(0, 0, 0);
  bottom: 0;
  left: 0;
  position: absolute;
  top: 0;
  width: 25px;
}

.number {
  background: white;
  border: 1px solid rgba(0, 0, 0);
  border-radius: 50%;
  font-size: 12px;
  height: 24px;
  left: 12px;
  line-height: 22px;
  position: absolute;
  text-align: center;
  top: 40px;
  width: 24px;
}

.step.active .number {
  background: black;
  color: white;
}

.step.first {
  top: 40px;
}

.step.first .number {
  top: 0;
}

.form-label {
  font-size: 16px;
  margin-bottom: 10px;
}

.form-group .MuiInputLabel-shrink,
.form-group .MuiOutlinedInput-notchedOutline legend {
  display: none !important;
}

.toggle-image {
  width: 40px;
}

.info {
  color: rgba(0, 0, 0, 0.5);
  font-size: 16px;
  margin-top: 10px;
  text-align: left;
}

.button-container {
  display: flex;
  justify-content: flex-end;
  margin: 40px 0 0;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Form/Form.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,2BAA2B;EAC3B,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,SAAS;EACT,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb","sourcesContent":[".form-container {\n  align-items: flex-start;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  width: 100%;\n}\n\n.form-steps {\n  width: 100%;\n}\n\n.form-group {\n  align-items: flex-start;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: flex-start;\n  min-width: 0;\n  padding: 40px 0 0 70px;\n  position: relative;\n}\n\n.step {\n  border-right: 1px solid rgba(0, 0, 0);\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 25px;\n}\n\n.number {\n  background: white;\n  border: 1px solid rgba(0, 0, 0);\n  border-radius: 50%;\n  font-size: 12px;\n  height: 24px;\n  left: 12px;\n  line-height: 22px;\n  position: absolute;\n  text-align: center;\n  top: 40px;\n  width: 24px;\n}\n\n.step.active .number {\n  background: black;\n  color: white;\n}\n\n.step.first {\n  top: 40px;\n}\n\n.step.first .number {\n  top: 0;\n}\n\n.form-label {\n  font-size: 16px;\n  margin-bottom: 10px;\n}\n\n.form-group .MuiInputLabel-shrink,\n.form-group .MuiOutlinedInput-notchedOutline legend {\n  display: none !important;\n}\n\n.toggle-image {\n  width: 40px;\n}\n\n.info {\n  color: rgba(0, 0, 0, 0.5);\n  font-size: 16px;\n  margin-top: 10px;\n  text-align: left;\n}\n\n.button-container {\n  display: flex;\n  justify-content: flex-end;\n  margin: 40px 0 0;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
